// ADR-0084 per-scan collection-method label.
//
// Shows HOW a specific scan's data was collected, driven by the report /
// scan-list envelope key `collection_method` ("securescan365" |
// "excel_import"), which the API serves from the envelope (post-ADR-0084
// scans) or injects from the provenance side-car (historical scans).
//
// Deliberately distinct from ScanMethodPill (SecureShield365.js), which
// states the customer's CURRENT scan tool in the upgrade section: this
// label is scoped to one scan, sits beside that scan's date, and uses
// "Collected with …" framing so a historical Legacy row never reads as
// contradicting the pill.
//
// Colour decision (operator, 2026-08-05 — not up for optimisation):
// legacy is NEUTRAL GREY (muted text, no coloured fill). Amber on a
// security assessment reads as "this data is suspect", which is false.
//
// Absent key → render NOTHING. No chip, no dash, no "unknown" text —
// the API never injects a placeholder and neither do we.
import React from "react";

export const SCAN_METHOD_COPY = {
  securescan365: { chip: "Collected with SecureScan365", short: "SecureScan365" },
  excel_import:  { chip: "Collected with Legacy scan", short: "Legacy scan" },
};

// Caption below the past-scans dropdown (visible while the selector is
// closed), rendered IN-FLOW as a boxed pill bound to the picker: the
// dropdown lays it out in a column under the button and stretches it to
// the button's exact width (operator restyle 2026-08-05 — the earlier
// absolute overlay landed on the Archived scans control at some widths).
// BOTH variants get a container so they read as two states of one thing,
// not one styled label and one bare string. The "Collected with" prefix
// is load-bearing: it makes the label past-tense and scoped to the
// selected scan, which is what keeps it from colliding with
// ScanMethodPill (the customer's CURRENT tool). Colours: green for
// SecureScan365, neutral grey for legacy (never amber — on a security
// assessment it reads as "this data is suspect", which is false).
export const ScanMethodChip = ({ method, T }) => {
  const copy = SCAN_METHOD_COPY[method];
  if (!copy) return null;
  const tone = method === "securescan365"
    ? {
        background: "rgba(83,196,109,0.14)",
        border: "1px solid rgba(83,196,109,0.35)",
        color: T.green,
      }
    : {
        background: "rgba(255,255,255,0.05)",
        border: `1px solid ${T.border}`,
        color: T.muted,
      };
  return (
    <span style={{
      fontSize: 11, fontWeight: 600, whiteSpace: "nowrap", textAlign: "center",
      padding: "2px 8px", borderRadius: 6, ...tone,
    }}>
      {copy.chip}
    </span>
  );
};

// Short form for the scan-history dropdown rows, beside each date.
export const ScanMethodOptionTag = ({ method, T }) => {
  const copy = SCAN_METHOD_COPY[method];
  if (!copy) return null;
  return (
    <span style={{
      fontSize: 10, fontWeight: 600, whiteSpace: "nowrap",
      color: method === "securescan365" ? T.green : T.muted,
    }}>
      {copy.short}
    </span>
  );
};
